export default __webpack_public_path__ + "static/media/Utvikling av The Lab for Design Thinkers (DT Lab).725ce07e.pdf";